module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ebCXz"))).then(() => parcelRequire('d0iPb'));